module.exports = __webpack_public_path__ + "img/Group1.fa9eccf7.svg";